import React from 'react';

const loding = ({open}) => {
    let loadingstyle = {
        display: `${open}`,
        position: `fixed`,
        left: '0px',
        top: '0px',
        width: '100%',
        height: '100vh',
        zIndex: '9999',
        background: "url(/images/Blocks-1s-200px.gif) center no-repeat rgba(255, 255, 255, .5)",
    }

    return (
        <div style={loadingstyle}></div>
    )
}


export default loding;
